function ArrowRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 12h14M12 5l7 7-7 7" strokeWidth={props.stroke || 1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowRightIcon
